module.exports = __webpack_public_path__ + "static/robothor-accessible-4a030d237dd2c36d530701f70e26fc93.gif";